var NewSegmentUITelemetryEventNames = /* @__PURE__ */ ((NewSegmentUITelemetryEventNames2) => {
  NewSegmentUITelemetryEventNames2["CreateOrEditColumnStart"] = "CreateOrEditColumnStart";
  NewSegmentUITelemetryEventNames2["SaveColumn"] = "SaveColumn";
  NewSegmentUITelemetryEventNames2["SaveColumnValid"] = "SaveColumnValid";
  NewSegmentUITelemetryEventNames2["SaveColumnSuccess"] = "SaveColumnSuccess";
  NewSegmentUITelemetryEventNames2["CancelColumnOp"] = "CancelColumnOp";
  return NewSegmentUITelemetryEventNames2;
})(NewSegmentUITelemetryEventNames || {});
export {
  NewSegmentUITelemetryEventNames
};
//# sourceMappingURL=NewSegmentUITelemetryEventNames.js.map
